import { render, staticRenderFns } from "./Jiechi.vue?vue&type=template&id=732e6cc4&scoped=true"
var script = {}
import style0 from "@/assets/css/public.scss?vue&type=style&index=0&id=732e6cc4&prod&lang=scss&scoped=true&external"
import style1 from "./Jiechi.vue?vue&type=style&index=1&id=732e6cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732e6cc4",
  null
  
)

export default component.exports